/**
 * @function event.registerPatientEvents
 * @param {Vuex} store
 * @param patientManager PatientManager
 */
export default function registerPatientEvents(store, patientManager){
  store.watch((state) => state.patientId, (newValue, oldValue) => {
    if (newValue){
      patientManager.getPatientSummary(newValue).then(patientSummary => {
        store.commit('setPatientSummary', patientSummary)
      })
    }else{
      store.commit('setPatientSummary', null)
    }
  })
}
